import { createElement, useEffect, useRef } from 'react';
import clamp from './clamp';
const dotdotdot = (container, clampValue) => {
    if (!container) {
        return;
    }
    if (clampValue) {
        clamp(container, { clamp: clampValue });
    }
};
export const Dotdotdot = ({ children, clamp: clampProp, className, screenReaderMaxLength, tagName: TagName = 'div', }) => {
    const containerRef = useRef(null);
    useEffect(() => {
        if (containerRef.current) {
            dotdotdot(containerRef.current, clampProp);
        }
    }, [clampProp]);
    const processedChildren = screenReaderMaxLength && typeof children === 'string'
        ? children.slice(0, screenReaderMaxLength)
        : children;
    return createElement(TagName, {
        className,
        ref: containerRef,
    }, processedChildren);
};
//# sourceMappingURL=Dotdotdot.js.map